module.exports = __webpack_public_path__ + "d2db4d6da49150c57456af68115d0b30.png";